// Rounds max up to a "nice" number and returns evenly spaced ticks from 0 to that number
export const niceScale = (max, tickCount = 4) => {
    if (!(max > 0)) return { max: 1, ticks: [0, 1] };

    const rough = max / tickCount;
    const magnitude = 10 ** Math.floor(Math.log10(rough));
    const normalized = rough / magnitude;
    const step = (normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10) * magnitude;
    const niceMax = Math.ceil(max / step) * step;

    const ticks = [];
    for (let value = 0; value <= niceMax + step / 2; value += step) {
        ticks.push(value);
    }

    return { max: niceMax, ticks };
};
